import {includes} from '@shared/helpers/collection'

import {AssignmentCode, AssignmentCodeValues, ClaimType} from '@web/core/constants'
import {ROUTER_ORDER_DETAIL} from '@web/core/routes'
import {ORDERS} from '@web/core/urls'

import {Assignment} from '../interfaces'

type ButtonInfo = {
    code: AssignmentCodeValues
    text: string
    pcUrl?: string
    mobileUrl?: string
    withdrawType?: ClaimType
    withdrawMessage?: string
}

const textAssignmentCodes = [
    AssignmentCode.CANCEL_INFO,
    AssignmentCode.REFUND_INFO,
    AssignmentCode.EXCHANGE_INFO,
    AssignmentCode.DELAY_REASON,
    AssignmentCode.EXCHANGE_INFO_BEFORE,
]

export const getAssignmentUrl = ({isMobileDisplay, assignment}: {isMobileDisplay: boolean; assignment: ButtonInfo}) => {
    const url = isMobileDisplay ? assignment.mobileUrl : assignment.pcUrl

    /**
     * 리뷰쓰기, 한달사용리뷰 case 인 경우
     * refresh 가능하도록 쿼리파라미터에 returnUrl을 추가 (bridge로 이동)
     */
    if (includes(assignment.code, [AssignmentCode.WRITE_REVIEW, AssignmentCode.WRITE_AFTER_USE_REVIEW])) {
        return `${url}&returnUrl=${ORDERS}${ROUTER_ORDER_DETAIL.POPUP_BRIDGE.getPath('/reviewCompleted/success')}`
    }

    /**
     * 구매확정연장 case
     * BE에서 FE의 브릿지페이지로 잘 넘어올 수 있도록 entryPoint를 수정하여 반영
     */
    if (includes(assignment.code, [AssignmentCode.EXTEND_PURCHASE_DECISION])) {
        return url?.replace('timeline', 'orderDetail')
    }

    return url
}

export const getAssignment = ({
    userActions,
    isMobileDisplay,
}: {
    userActions: ButtonInfo[]
    isMobileDisplay: boolean
}): Assignment[] => {
    return userActions.map((assignment) => {
        return {
            ...assignment,
            type: includes(assignment.code, textAssignmentCodes) ? 'text' : 'button',
            url: getAssignmentUrl({isMobileDisplay, assignment}),
        }
    })
}
